import React, { useEffect } from "react";
import List from "@mui/material/List";
import BiotechIcon from "@mui/icons-material/Biotech";
import authService from "../../Services/auth.service";
import {
  Box,
  Collapse,
  Divider,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import FeedIcon from "@mui/icons-material/Feed";
import DescriptionTwoToneIcon from "@mui/icons-material/DescriptionTwoTone";
import SettingsSuggestTwoToneIcon from "@mui/icons-material/SettingsSuggestTwoTone";
import GroupAddTwoToneIcon from "@mui/icons-material/GroupAddTwoTone";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import DocumentScannerTwoToneIcon from "@mui/icons-material/DocumentScannerTwoTone";
import { MENU } from "../../Config";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import StarBorder from "@mui/icons-material/StarBorder";
export default function MenuSideBar({ handleDrawerOpen }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [subMenu, setSubmenu] = React.useState("");

  const onClickSubNemu = (menu) => {
    if (menu === subMenu) {
      setSubmenu("");
    } else {
      setSubmenu(menu);
    }
  };

  return (
    <div>
      <List>
        <Box>
          {/* <ListItemButton
            sx={{
              borderTopRightRadius: "1.2rem",
              borderBottomRightRadius: "1.2rem",
              color: "black",
              mb: 0.5,
            }}
            onClick={() => {
              // opt.submenu.length > 0
              //   ? handleClickSubOpen(opt, index)
              //   : navigate(opt.url);
              // localStorage.setItem("menu", opt.name);
              // localStorage.removeItem("sub_menu");
              // handleDrawerOpen();
            }}
          >
            <ListItemIcon sx={{ minWidth: "32px" }}>
              <DescriptionTwoToneIcon />
            </ListItemIcon>
            <ListItemText primary={"All Lab Result"} />
          </ListItemButton> */}
          {authService.permission("ALL_LAB_REQUEST") && (
            <ListItemButton
              sx={{
                borderTopRightRadius: "1.2rem",
                borderBottomRightRadius: "1.2rem",
                color: "black",
                mb: 0.5,
              }}
              onClick={() => {
                navigate("lab");
                handleDrawerOpen();
              }}
            >
              <ListItemIcon sx={{ minWidth: "32px" }}>
                <DescriptionTwoToneIcon />
              </ListItemIcon>
              <ListItemText primary={"All Lab Request"} />
            </ListItemButton>
          )}
          {(authService.permission("USER_NEWS") ||
            authService.permission("USER") ||
            authService.permission("USERS_GROUP") ||
            authService.permission("DEPARTMENT") ||
            authService.permission("LAB_FORM")) && (
            <>
              <ListItemButton
                onClick={() => onClickSubNemu("Data Master")}
                sx={{
                  borderTopRightRadius: "1.2rem",
                  borderBottomRightRadius: "1.2rem",
                  color: "black",
                  mb: 0.5,
                }}
              >
                <ListItemIcon>
                  <ManageAccountsTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Data Master" />
                {subMenu === "Data Master" ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse
                in={subMenu === "Data Master"}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {authService.permission("USER") && (
                    <ListItemButton
                      sx={{
                        pl: 4,
                        borderTopRightRadius: "1.2rem",
                        borderBottomRightRadius: "1.2rem",
                        color: "black",
                        mb: 0.5,
                      }}
                      onClick={() => {
                        navigate("lab/users");
                        handleDrawerOpen();
                      }}
                    >
                      <ListItemIcon>
                        <ManageAccountsTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="ผู้ใช้งาน" />
                    </ListItemButton>
                  )}
                  {authService.permission("USERS_GROUP") && (
                    <ListItemButton
                      sx={{
                        pl: 4,
                        borderTopRightRadius: "1.2rem",
                        borderBottomRightRadius: "1.2rem",
                        color: "black",
                        mb: 0.5,
                      }}
                      onClick={() => {
                        navigate("lab/user-group");
                        handleDrawerOpen();
                      }}
                    >
                      <ListItemIcon>
                        <ManageAccountsTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="กลุ่มผู้ใช้งาน" />
                    </ListItemButton>
                  )}
                  {authService.permission("DEPARTMENT") && (
                    <ListItemButton
                      sx={{
                        pl: 4,
                        borderTopRightRadius: "1.2rem",
                        borderBottomRightRadius: "1.2rem",
                        color: "black",
                        mb: 0.5,
                      }}
                      onClick={() => {
                        navigate("lab/department");
                        handleDrawerOpen();
                      }}
                    >
                      <ListItemIcon>
                        <ManageAccountsTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="จุดตรวจ" />
                    </ListItemButton>
                  )}
                  {authService.permission("LAB_FORM") && (
                    <ListItemButton
                      sx={{
                        pl: 4,
                        borderTopRightRadius: "1.2rem",
                        borderBottomRightRadius: "1.2rem",
                        color: "black",
                        mb: 0.5,
                      }}
                      onClick={() => {
                        navigate("lab/lab-form");
                        handleDrawerOpen();
                      }}
                    >
                      <ListItemIcon>
                        <ManageAccountsTwoToneIcon />
                      </ListItemIcon>
                      <ListItemText primary="LAB FORM" />
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
            </>
          )}
          {authService.permission("SETTING") && (
            <ListItemButton
              sx={{
                borderTopRightRadius: "1.2rem",
                borderBottomRightRadius: "1.2rem",
                color: "black",
                mb: 0.5,
              }}
              onClick={() => {
                navigate("lab/setting");
                handleDrawerOpen();
              }}
            >
              <ListItemIcon sx={{ minWidth: "32px" }}>
                <SettingsSuggestTwoToneIcon />
              </ListItemIcon>
              <ListItemText primary={"ตั้งค่าระบบ"} />
            </ListItemButton>
          )}
        </Box>
      </List>
    </div>
  );
}
